import React, { useState } from "react";
import EducationManager from "./EducationManager";
import ExperienceManager from "./ExperienceManager";
import SkillsManager from "./SkillsManager";
import CertificateManagement from "./CertificateManagement";

import ProjectsManager from "./ProjectsManager";

const ResumeManagement = () => {
    const [activeTab, setActiveTab] = useState("education");

    const tabs = [
        { id: "education", label: "Education" },
        { id: "skills", label: "Professional Skills" },
        { id: "projects", label: "Projects" },
        { id: "experience", label: "Experience" },
        { id: "certificates", label: "Certificates" },
    ];

    return (
        <div className="min-h-screen text-sm text-stone-600 dark:text-white">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-800 dark:text-white">
                    Resume Management
                </h1>
                <p className="mt-1 text-gray-500 dark:text-gray-400">
                    Manage your education, skills, projects, experience, and certificates.
                </p>
            </div>

            {/* Tabs */}
            <div className="mb-8 border-b border-gray-200 dark:border-gray-700">
                <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="Tabs">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`
                whitespace-nowrap border-b-2 py-4 px-4 text-sm font-medium transition-all duration-300 rounded-t-lg outline-none focus:outline-none
                ${activeTab === tab.id
                                    ? "border-primary text-primary bg-primary/5 dark:bg-primary/10"
                                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-primary hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-gray-800/50 dark:hover:text-gray-300"
                                }
              `}
                        >
                            {tab.label}
                        </button>
                    ))}
                </nav>
            </div>

            {/* Content */}
            <div className="mt-6">
                {activeTab === "education" && <EducationManager />}
                {activeTab === "skills" && <SkillsManager />}
                {activeTab === "projects" && <ProjectsManager />}
                {activeTab === "experience" && <ExperienceManager />}
                {activeTab === "certificates" && <CertificateManagement />}
            </div>
        </div>
    );
};

export default ResumeManagement;
